export const piiDataAttributes = {
  'data-recite-skip': 'true',
  'data-dd-privacy': 'mask',
};
